import { Component, OnInit } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { AuthServiceService } from '../../shareModule/services/auth-service.service';
import { ToastrService } from 'ngx-toastr';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-new-forgot-password',
  templateUrl: './new-forgot-password.component.html',
  styleUrls: ['./new-forgot-password.component.scss']
})
export class NewForgotPasswordComponent implements OnInit {

  forgotPassword: FormGroup;
  submitted = false;

  constructor(
    private modalService: NgbModal,
    private formBuilder: FormBuilder,
    private auth: AuthServiceService,
    private toastr: ToastrService
  ) { }

  ngOnInit(): void {
    this.forgotPassword = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]]
    });
  }

  get forgotV() {
    return this.forgotPassword.controls;
  }

  dismiss() {
    this.modalService.dismissAll();
  }

  forgot_password() {
    this.submitted = true;

    if (this.forgotPassword.invalid) {
      return;
    }

    let formData = new FormData();
    formData.append('email', this.forgotPassword.value.email);

    this.auth.forgot_password_myvip(formData).subscribe((response: any) => {

      this.modalService.dismissAll();
      this.submitted = false;
      this.forgotPassword.reset();
      
      Swal.fire(
        'Reset password email sent',
        'Follow the steps sent in email to reset your password.',
        'success'
      );

    }, (e) => {
      if (e.status == 400) {
        this.toastr.error(e.error.message)
        this.modalService.dismissAll()
      }
    });
  }

}
